import { type PropsWithChildren } from 'react';

import SkipToMain from '@/components/accessibility/SkipToMain';
import ClientProviders, { type ClientProvidersProps } from '@/components/layout/ClientProviders';
import Devtools from '@/components/layout/Devtools';
import LayoutScripts from '@/components/layout/LayoutScripts';
import RecaptchaModal from '@/components/layout/RecaptchaModal';
import ToastNotification from '@/components/ui/ToastNotification';

export type PageWrapperProps = { nonce?: string | null } & ClientProvidersProps;

export default function PageWrapper({
	children,
	nonce,
	...clientProvidersProps
}: PropsWithChildren<PageWrapperProps>) {
	return (
		<ClientProviders {...clientProvidersProps}>
			<LayoutScripts nonce={nonce} />
			<SkipToMain />
			{children}
			<Devtools />
			<RecaptchaModal />
			<ToastNotification />
		</ClientProviders>
	);
}
